import { render } from "./PropertyDefault.vue?vue&type=template&id=327afd66&scoped=true&ts=true"
import script from "./PropertyDefault.vue?vue&type=script&lang=ts"
export * from "./PropertyDefault.vue?vue&type=script&lang=ts"

import "./PropertyDefault.vue?vue&type=style&index=0&id=327afd66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327afd66"]])

export default __exports__